import Link from "next/link";
import { FunctionComponent } from "react";

// import header images
import Logo from "../assets/svg/logo.svg";
import { StepType } from "types";

const Header: FunctionComponent<StepType> = (props) => {
  return (
    <header className="header">
      {/* page links and accesibility will be added */}
      <div className="header__inner">
        <nav role="navigation" className="header__flex">
          <Logo alt="Sea Museum" width="45" height="54" viewBox="0 0 79 99" />
          <div className="header__steps">
            <ul className="ticket-steps">
              <li className="ticket-steps__step">
                {props.step > 1 ? (
                  <Link href={`/${props.urlCode}`}>
                    <a className={`ticket-steps__step-link ticket-steps__step-link--clickable`}>
                      1.<span> Tickets</span>
                    </a>
                  </Link>
                ) : (
                  <a className={`ticket-steps__step-link is-active`}>
                    1.<span> Tickets</span>
                  </a>
                )}
              </li>
              <li className="ticket-steps__step">
                {props.step > 2 ? (
                  <Link href={`/details/${props.urlCode}`}>
                    <a className={`ticket-steps__step-link ticket-steps__step-link--clickable`}>
                      2.<span> Details</span>
                    </a>
                  </Link>
                ) : (
                  <a className={`ticket-steps__step-link ${props.step === 2 ? "is-active" : ""}`}>
                    2.<span> Details</span>
                  </a>
                )}
              </li>
              <li className="ticket-steps__step">
                <a className={`ticket-steps__step-link ${props.step === 3 ? "is-active" : ""}`}>
                  3.<span> Payment</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
